import { RootState } from 'core';

export const cartItemDeleteError = (action: any, prevState: RootState) => {
  const { meta } = action;
  const { productCode } = meta.payload;

  const product = action.payload?.items?.find((item: any) => item.productCode === productCode);

  const listName = meta.payload?.itemListName ?? product?.itemListName ?? '';

  return {
    event: 'analytics-event', // always this event name
    event_parameters: {
      event_name: `interaction_${listName}`,
      cd_interaction_detail: `toast:erro-erro-remover-item`,
      cd_quantidade_itens_solicitados: action.meta.payload.quantity,
    },
  };
};
